import Button from "@commons/Button";
import Text from "@commons/Typography/Text";
import AddIcon from "@mui/icons-material/Add";

interface MapButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  hidden?: boolean;
}

function MapButton({ children, onClick, hidden = false }: MapButtonProps) {
  if (hidden) return null;

  return (
    <div className="absolute top-2 left-2 xs:top-4 xs:left-4 z-10">
      <Button
        onClick={onClick}
        customVariant="secondary"
        size="auto"
        startIcon={<AddIcon />}
      >
        <Text size="sm">{children}</Text>
      </Button>
    </div>
  );
}

export default MapButton;
